import { inject, Injectable } from '@angular/core';
import { PickupStore, UserAddress } from '@lentau/address/shared/interfaces';
import { MissionAddressModeCacheService } from './mission-address-mode-cache.service';
import { AddressesFacade } from '@lentau/delivery-mode/store/addresses.facade';
import { MissionAddressMode } from './types';
import { DeliveryModeFacade } from '@lentau/delivery-mode/store/delivery-mode.facade';
import { DeliveryMode } from '@lentau/delivery-mode/shared/enums';
import { deliveryModeDefault } from '@lentau/delivery-mode/shared/constants';

@Injectable({
  providedIn: 'root',
})
export class MissionAddressModeCacheFacade {
  private missionAddressModeCacheService: MissionAddressModeCacheService = inject(MissionAddressModeCacheService);
  private addressesFacade: AddressesFacade = inject(AddressesFacade);
  private deliveryModeFacade: DeliveryModeFacade = inject(DeliveryModeFacade);

  public checkCache(): void {
    const missionAddressMode: MissionAddressMode = this.missionAddressModeCacheService.getInitValue();

    if (!missionAddressMode) {
      this.deliveryModeFacade.setCache({ type: deliveryModeDefault });
      return;
    }

    const isDelivery: boolean = missionAddressMode.type === DeliveryMode.Delivery;

    this.deliveryModeFacade.setCache({
      type: missionAddressMode.type,
      storeId: isDelivery ? null : (missionAddressMode.missionAddress as PickupStore)?.id,
      addressId: isDelivery ? +(missionAddressMode.missionAddress as UserAddress)?.Id : null,
    });

    this.addressesFacade.setCache(isDelivery ? (missionAddressMode.missionAddress as UserAddress) : null);

    this.deliveryModeFacade.setPickupCache(
      isDelivery ? null : (missionAddressMode.missionAddress as PickupStore),
      missionAddressMode.isDefaultStore
    );
  }

  public updateCache(deliveryAddress: MissionAddressMode): void {
    if (deliveryAddress) {
      this.missionAddressModeCacheService.updateCache(deliveryAddress);
    } else {
      this.missionAddressModeCacheService.clearCache();
    }
  }

  public clearCache(): void {
    this.missionAddressModeCacheService.clearCache();
  }
}
